import { render, staticRenderFns } from "./EmailDetails.vue?vue&type=template&id=27d1f82a&scoped=true&"
import script from "./EmailDetails.vue?vue&type=script&lang=js&"
export * from "./EmailDetails.vue?vue&type=script&lang=js&"
import style1 from "./EmailDetails.vue?vue&type=style&index=1&id=27d1f82a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d1f82a",
  null
  
)

export default component.exports